export class FileUtilities {
  public static fromBase64ToUint8Array(base64: string): Uint8Array {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    return new Uint8Array(byteNumbers);
  }

  public static fromUint8ArrayToFile(uint8Array: Uint8Array, originalFileName: string, mimeType: string): File {
    const blob = new Blob([uint8Array as BlobPart], { type: mimeType });

    return new File([blob], originalFileName, { type: blob.type });
  }

  public static async fromUrlToFile(url: string, filename: string, mimeType?: string): Promise<File> {
    const response: Response = await fetch(url);
    const blob: Blob = await response.blob();
    const type: string = mimeType ?? blob.type;

    return new File([blob], filename, { type });
  }

  public static async fromImageUrlToBase64(url: string): Promise<string> {
    return fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = (): void => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          }),
      );
  }

  public static fromFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (): void => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  public static async fromFileToBinary(file: File): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (): void => {
        if (reader.result instanceof ArrayBuffer) {
          resolve(reader.result);
        } else {
          reject(new Error('Unexpected result type'));
        }
      };
      reader.onerror = (): void => reject(reader.error);
      reader.readAsArrayBuffer(file);
    });
  }
}
